<script setup>
import _ from 'lodash'
const props = defineProps({
  icon: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: null,
  },
  slug: {
    type: String,
    default: null,
  },
  expandedByDefault: {
    type: Boolean,
    default: false,
  },
  eventType: {
    type: String,
    default: 'PDP',
  },
})

const id = computed(
  () => 'accordion-' + (props.slug || _.snakeCase(props.title)),
)
const accordionStore = useAccordionItems()
const accordion = inject('accordion')
const expanded = computed(() => {
  if (!accordion.id.value) {
    return props.expandedByDefault
  }
  return accordionStore.isItemExpanded(accordion.id.value, id.value)
})
const liClasses = computed(() => ({
  'accordion-item': true,
  'is-active': expanded.value,
}))

function toggle(event) {
  if (event) {
    event.stopPropagation()
  }
  accordionStore.toggleItem(accordion.id.value, id.value)
}

function expand(event) {
  if (event) {
    event.stopPropagation()
  }
  accordionStore.toggleItem(accordion.id.value, id.value, true)
}

onMounted(() => {
  if (props.expandedByDefault) {
    accordionStore.openAccordionItemByDefault(accordion.id.value, id.value)
  }
})

defineExpose({
  toggle,
  expand,
})
</script>

<template>
  <div :class="liClasses" role="presentation" data-accordion-item>
    <a
      :id="id"
      href="#"
      class="accordion-title"
      :class="{ 'with-image': !!icon }"
      role="button"
      :aria-expanded="expanded"
      :aria-pressed="expanded"
      :aria-controls="`${id}-content`"
      :aria-labelledby="`${id}-label`"
      @click.prevent="toggle"
    >
      <slot name="title">
        <img
          v-if="icon"
          :src="icon"
          role="presentation"
          height="40"
          width="40"
        />
        <div :id="`${id}-label`" class="h2">{{ title }}</div>
        <span v-if="subtitle" class="included">{{ subtitle }}</span>
      </slot>
    </a>
    <div
      v-show="expanded"
      :id="`${id}-content`"
      class="accordion-content"
      role="region"
      data-tab-content
      :aria-labelledby="`${id}-label`"
      :aria-hidden="!expanded"
    >
      <slot></slot>
    </div>
  </div>
</template>
